module.exports = __webpack_public_path__ + "static/media/sup_can.0dd01657.png";